// src/firebase.js
import { initializeApp } from "firebase/app";
// [추가] Firestore 인스턴스 import - 비용 최적화를 위한 직접 읽기 지원
import { getFirestore } from "firebase/firestore";
// [추가] Functions 인스턴스 import
import { getFunctions } from "firebase/functions";
// [추가] Firebase Auth import - 익명 인증 지원
import { getAuth } from "firebase/auth";
// [통합] environment.js에서 환경 판단 함수 import
import { getEnvironment } from './utils/environment';

// [추가] 환경별 Firebase 설정 파일 import
import { devFirebaseConfig } from './config/firebase-dev-config';
import { prodFirebaseConfig } from './config/firebase-prod-config';

// [통합] environment.js의 getEnvironment 사용하여 환경 판단
const environment = getEnvironment();
// [매핑] Pi 환경(3가지)을 Firebase 환경(2가지)으로 매핑
const firebaseEnv = environment === 'production' ? 'production' : 'development';

// [수정] 환경에 따라 적절한 Firebase 설정 선택
const firebaseConfig = firebaseEnv === 'production'
  ? prodFirebaseConfig
  : devFirebaseConfig;

// [수정] 선택된 프로젝트 정보 로깅 - 두 환경 정보 모두 출력
console.log('[Firebase] Pi Environment:', environment);
console.log('[Firebase] Firebase Environment:', firebaseEnv);
console.log('[Firebase] Using project:', firebaseConfig.projectId);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// [추가] Firestore 인스턴스 초기화 - 비용 최적화를 위한 직접 읽기 지원
const db = getFirestore(app);

// [추가] Firebase Auth 인스턴스 초기화 - 익명 인증 지원
const auth = getAuth(app);

// [추가] Functions 인스턴스 초기화
// 🔥 [CORS Fix] 리전 명시 - Cloud Functions가 asia-northeast3에 배포되어 있음
const functions = getFunctions(app, "asia-northeast3");

// [신규] Mainnet 인스턴스 - Admin 메인넷 배포용
let mainnetFunctions = null;
let mainnetDb = null;
if (firebaseEnv !== 'production') {
  // 테스트넷/샌드박스 환경에서는 메인넷 앱 별도 초기화
  const mainnetApp = initializeApp(prodFirebaseConfig, 'mainnet');
  // 🔥 [CORS Fix] 메인넷 Functions도 동일 리전 지정
  mainnetFunctions = getFunctions(mainnetApp, "asia-northeast3");
  mainnetDb = getFirestore(mainnetApp);
  console.log('[Firebase] Mainnet App initialized for cross-project deployment (Functions + Firestore)');
}

// 기본 export는 app
export default app;

// Firestore, Auth, Functions 인스턴스 export
export { db, auth, functions, mainnetFunctions, mainnetDb };